import React from 'react';

const SvgEmail = props => (
  <svg
    id="prefix__img_email"
    width={props.size || 20.201}
    height={props.size || 15.488}
    viewBox="0 0 20.201 15.488"
    fill="#104eb2"
    {...props}
  >
    <g id="email_svg__email" transform="translate(0 -59.733)">
      <g
        id="email_svg__Grupo_412"
        data-name="Grupo 412"
        transform="translate(0 59.733)"
      >
        <g id="email_svg__Grupo_411" data-name="Grupo 411">
          <path
            id="email_svg__Trazado_417"
            data-name="Trazado 417"
            className="email_svg__cls-1"
            d="M19.192 59.733H1.01A1.01 1.01 0 000 60.743v13.468a1.01 1.01 0 001.01 1.01h18.182a1.01 1.01 0 001.01-1.01V60.743a1.01 1.01 0 00-1.01-1.01zm.337 14.478a.337.337 0 01-.337.337H1.01a.337.337 0 01-.337-.337V60.743a.337.337 0 01.337-.337h18.182a.337.337 0 01.337.337v13.468z"
            transform="translate(0 -59.733)"
          />
          <path
            id="email_svg__Trazado_418"
            data-name="Trazado 418"
            className="email_svg__cls-1"
            d="M51.334 93.866a.336.336 0 00-.246.078l-7.768 6.525a.673.673 0 01-.867 0l-7.768-6.525a.337.337 0 00-.433.516l7.768 6.525a1.345 1.345 0 001.733 0l7.768-6.525a.337.337 0 00-.187-.593z"
            transform="translate(-32.786 -92.518)"
          />
          <path
            id="email_svg__Trazado_419"
            data-name="Trazado 419"
            className="email_svg__cls-1"
            d="M39.134 272.933a.337.337 0 00-.325.1l-4.709 5.055a.337.337 0 10.492.459L39.3 273.5a.337.337 0 00-.168-.564z"
            transform="translate(-32.659 -264.513)"
          />
          <path
            id="email_svg__Trazado_420"
            data-name="Trazado 420"
            className="email_svg__cls-1"
            d="M341.789 273.038a.337.337 0 10-.492.459l4.714 5.051a.337.337 0 00.492-.459z"
            transform="translate(-327.738 -264.513)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgEmail;
